import React, { FC } from "react";
import { GovPrograms } from "./gov-programs";

export const GovProgramsContainer: FC = () => {

  return <GovPrograms />;
};
